import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getBrands() {
  const r = await axios.get(`${API_BASE}/tempsor/brands`, { headers: authHeader() });
  return r.data;
}

export async function getSales({ fromAt, toAt, brands } = {}) {
  const params = {};
  if (fromAt) params.from_at = fromAt;
  if (toAt) params.to_at = toAt;
  if (brands && brands.length) params.brands = brands.join(',');
  const r = await axios.get(`${API_BASE}/tempsor/sales`, { headers: authHeader(), params });
  return r.data;
}

export async function listSnapshots() {
  const r = await axios.get(`${API_BASE}/tempsor/snapshots`, { headers: authHeader() });
  return r.data;
}

export async function createSnapshot(name, notes) {
  const r = await axios.post(`${API_BASE}/tempsor/snapshots`,
    { name, notes }, { headers: authHeader() });
  return r.data;
}

export async function deleteSnapshot(id) {
  const r = await axios.delete(`${API_BASE}/tempsor/snapshots/${id}`, { headers: authHeader() });
  return r.data;
}

export async function refreshOldInventory() {
  const r = await axios.post(`${API_BASE}/tempsor/refresh-old-inventory`,
    {}, { headers: authHeader() });
  return r.data;
}

export async function refreshNewCatalog() {
  const r = await axios.post(`${API_BASE}/tempsor/refresh-new-catalog`,
    {}, { headers: authHeader() });
  return r.data;
}
